import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStarEllipse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    viewBox='0 0 14 14'
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='m7.004 4.52-.186.559a2.75 2.75 0 0 1-1.735 1.739l-.549.184.54.18A2.75 2.75 0 0 1 6.82 8.92l.187.56.188-.562a2.75 2.75 0 0 1 1.74-1.737l.542-.18-.55-.185a2.75 2.75 0 0 1-1.732-1.731zm.945-2.684c-.306-.91-1.594-.909-1.897.002l-.894 2.688a1 1 0 0 1-.631.633l-2.683.9c-.91.305-.908 1.595.004 1.897l2.677.887a1 1 0 0 1 .634.632l.897 2.688c.304.91 1.592.91 1.897 0l.9-2.689a1 1 0 0 1 .633-.632l2.672-.887c.912-.303.914-1.591.004-1.897l-2.679-.9a1 1 0 0 1-.63-.63z'
      clipRule='evenodd'
    />
    <path
      fill='currentColor'
      d='M2 0a.667.667 0 0 0-.667.667v.666H.667a.667.667 0 0 0 0 1.334h.666v.666a.667.667 0 0 0 1.334 0v-.666h.666a.667.667 0 0 0 0-1.334h-.666V.667A.667.667 0 0 0 2 0M12 10a.667.667 0 0 0-.667.667v.666h-.666a.667.667 0 0 0 0 1.334h.666v.666a.667.667 0 0 0 1.334 0v-.666h.666a.667.667 0 0 0 0-1.334h-.666v-.666A.667.667 0 0 0 12 10'
    />
  </svg>
);
export default SvgStarEllipse;
